import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { SummaryWall } from "@faire/retailer-visitor-shared/features/PointOfSale/components/SummaryWall";
import { LazyArchivedItems } from "@faire/retailer-visitor-shared/views/point-of-sale/archived/LazyArchivedItems";
import { LazyPOSConnectCloverApp } from "@faire/retailer-visitor-shared/views/point-of-sale/connect-clover-app/LazyPOSConnectCloverApp";
import { LazyPOSConnectShopifyApp } from "@faire/retailer-visitor-shared/views/point-of-sale/connect-shopify-app/LazyPOSConnectShopifyApp";
import { LazyPOSHome } from "@faire/retailer-visitor-shared/views/point-of-sale/landing-page/LazyPOSHome";
import { LazyLinkedItems } from "@faire/retailer-visitor-shared/views/point-of-sale/linked/LazyLinkedItems";
import { LazySuggestedMatches } from "@faire/retailer-visitor-shared/views/point-of-sale/matches/LazySuggestedMatches";
import { LazyPOSOnboardingPages } from "@faire/retailer-visitor-shared/views/point-of-sale/onboarding/LazyPOSOnboardingPages";
import { LazyOrderManager } from "@faire/retailer-visitor-shared/views/point-of-sale/order-manager/LazyOrderManager";
import { LazyBrandOrderDetails } from "@faire/retailer-visitor-shared/views/point-of-sale/orders/brandOrderToken/LazyBrandOrderDetails";
import { LazyOrderDetails } from "@faire/retailer-visitor-shared/views/point-of-sale/orders/orderToken/brandToken/LazyOrderDetails";
import { LazyPOSSettings } from "@faire/retailer-visitor-shared/views/point-of-sale/settings/LazyPOSSettings";
import { LazyUnlinkedItems } from "@faire/retailer-visitor-shared/views/point-of-sale/unlinked/LazyUnlinkedItems";
import { PageLoader } from "@faire/web--source/ui/CircleSpinner";
import { Switch } from "@faire/web--source/ui/routing/Switch";
import { Route } from "@faire/web-api--source/Route";
import { props as pointOfSaleProps } from "@faire/web-api--source/routes/point-of-sale";
import { props as posArchivedItemsProps } from "@faire/web-api--source/routes/point-of-sale/archived";
import { props as posConnectCloverAppProps } from "@faire/web-api--source/routes/point-of-sale/connect-clover-app";
import { props as posConnectShopifyAppProps } from "@faire/web-api--source/routes/point-of-sale/connect-shopify-app";
import { props as posLinkedItemsProps } from "@faire/web-api--source/routes/point-of-sale/linked";
import { props as posSuggestedMatchesProps } from "@faire/web-api--source/routes/point-of-sale/matches";
import { props as posOnboardingProps } from "@faire/web-api--source/routes/point-of-sale/onboarding";
import { props as posOrderManagerProps } from "@faire/web-api--source/routes/point-of-sale/order-manager/orderToken";
import { props as posBrandOrderDetailsProps } from "@faire/web-api--source/routes/point-of-sale/orders/brandOrderToken";
import { props as posOrderDetailsProps } from "@faire/web-api--source/routes/point-of-sale/orders/orderToken/brandToken";
import { props as posSettingsProps } from "@faire/web-api--source/routes/point-of-sale/settings";
import { props as posUnlinkedItemsProps } from "@faire/web-api--source/routes/point-of-sale/unlinked";
import React, { Suspense } from "react";
export var POSRouter = function(param) {
    var orderManager = param.orderManager, onboarding = param.onboarding;
    // Order manager and onboarding must be rendered exclusively, as they have different header contents,
    // and will cause flickering if rendered together in NextJS on page navigation.
    if (orderManager) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoader, {}),
            children: /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posOrderManagerProps), {
                render: function() {
                    return /*#__PURE__*/ _jsx(SummaryWall, {
                        linkedOnly: true,
                        children: /*#__PURE__*/ _jsx(LazyOrderManager, {})
                    });
                }
            }))
        });
    }
    if (onboarding) {
        return /*#__PURE__*/ _jsx(Suspense, {
            fallback: /*#__PURE__*/ _jsx(PageLoader, {}),
            children: /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posOnboardingProps), {
                render: function() {
                    return /*#__PURE__*/ _jsx(SummaryWall, {
                        children: /*#__PURE__*/ _jsx(LazyPOSOnboardingPages, {})
                    });
                }
            }))
        });
    }
    return /*#__PURE__*/ _jsx(Suspense, {
        fallback: /*#__PURE__*/ _jsx(PageLoader, {}),
        children: /*#__PURE__*/ _jsxs(Switch, {
            children: [
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posSettingsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            children: /*#__PURE__*/ _jsx(LazyPOSSettings, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posOrderDetailsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyOrderDetails, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posBrandOrderDetailsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyBrandOrderDetails, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posSuggestedMatchesProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazySuggestedMatches, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posLinkedItemsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyLinkedItems, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posUnlinkedItemsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyUnlinkedItems, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posArchivedItemsProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            linkedOnly: true,
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyArchivedItems, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posConnectCloverAppProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            children: /*#__PURE__*/ _jsx(LazyPOSConnectCloverApp, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, posConnectShopifyAppProps), {
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            children: /*#__PURE__*/ _jsx(LazyPOSConnectShopifyApp, {})
                        });
                    }
                })),
                /*#__PURE__*/ _jsx(Route, _object_spread_props(_object_spread({}, pointOfSaleProps), {
                    exact: true,
                    render: function() {
                        return /*#__PURE__*/ _jsx(SummaryWall, {
                            allowNotifications: true,
                            children: /*#__PURE__*/ _jsx(LazyPOSHome, {})
                        });
                    }
                }))
            ]
        })
    });
};
